// Log Job's header, Direction 1 (2026-09-08). Phone: a compact context header
// (back chevron · customer · date) — the task's app bar. Tablet + desktop: a
// breadcrumb bar in the shell-header vocabulary ("Ruta › name" + "Back to
// route"). There is NO wordmark on any layout (founder choice C): the page is
// a task inside the app, not a login screen. Both back controls navigate the
// way the old "← Atrás" did; the page owns the destination.
import { ChevronLeft } from 'lucide-react';
import { useIntl } from 'react-intl';
import { capitalizeWords } from '../utils/date/formatDate';
import { layoutStyles as L } from './logJobLayoutStyles';
import { styles } from './logJobStyles';

/** "Vie 5 sep" — a calendar date, noon-anchored so it can never shift a day. */
export function formatLogJobShortDate(ymd, locale) {
  if (!ymd) return '';
  const d = new Date(`${String(ymd).slice(0, 10)}T12:00:00`);
  if (Number.isNaN(d.getTime())) return '';
  return capitalizeWords(d.toLocaleDateString(locale, { weekday: 'short', day: 'numeric', month: 'short' }));
}

export default function LogJobHeader({ layout, customerName, dateLabel, onBack }) {
  const intl = useIntl();
  const backLabel = intl.formatMessage({ id: 'common.back', defaultMessage: 'Back' });

  if (layout === 'phone') {
    return (
      <header style={L.compactHeader} data-testid="logjob-header" data-layout="phone">
        <button type="button" style={L.compactHeaderBack} onClick={onBack} aria-label={backLabel} data-testid="logjob-back">
          <ChevronLeft size={24} strokeWidth={2.25} aria-hidden />
        </button>
        <div style={L.compactHeaderText}>
          <div style={L.compactHeaderTitle}>{customerName}</div>
          {dateLabel ? <div style={L.compactHeaderSub}>{dateLabel}</div> : null}
        </div>
      </header>
    );
  }

  return (
    <header style={L.crumbBar} data-testid="logjob-header" data-layout={layout}>
      <nav style={L.crumbText} aria-label={intl.formatMessage({ id: 'nav.route', defaultMessage: 'Route' })}>
        <button type="button" style={L.crumbRoot} onClick={onBack} data-testid="logjob-crumb-route">
          {intl.formatMessage({ id: 'nav.route', defaultMessage: 'Route' })}
        </button>
        <span style={L.crumbSep} aria-hidden>›</span>
        <span style={L.crumbName}>{customerName}</span>
      </nav>
      <button type="button" style={{ ...styles.backButton, ...L.crumbBackButton }} onClick={onBack} data-testid="logjob-back">
        <span aria-hidden>‹</span> {intl.formatMessage({ id: 'logJob.header.backToRoute', defaultMessage: 'Back to route' })}
      </button>
    </header>
  );
}
